import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	placeholder: {
		id: 'polaris-ideas.view-content.idea-list.cell.cells.fuzzy-date-field.placeholder',
		defaultMessage: 'No date set',
		description: 'Table cell placeholder for fuzzy date field when there is no date set.',
	},
});
